import {IAddFruit} from "src/store/actions";
import {IAppState} from "src/store/models";

export const addFruitReducer = (state: IAppState, action: IAddFruit) => {
    const oldBox = state.boxes[action.payload.boxId];
    return {
        ...state,
        boxes: {
            ...state.boxes,
            [action.payload.boxId]: {
                ...oldBox,
                fruitsIds: [...oldBox.fruitsIds, action.payload.fruitId]
            }
        },
        fruits: {
            ...state.fruits,
            [action.payload.fruitId]: {
                box: action.payload.boxId,
                kind: action.payload.kind || oldBox.defaultKind,
                size: action.payload.size || oldBox.defaultSize
            }
        }

    };
};


// WEBPACK FOOTER //
// ./src/store/reducers/adding/addFruitReducer.ts